var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0498 4.65039H11.0498H24.9498H24.9499C25.5473 4.65036 26.0328 4.65088 26.4264 4.68304C26.8384 4.7167 27.2041 4.78805 27.5436 4.96102C28.0799 5.23426 28.5159 5.67026 28.7891 6.20651C28.9621 6.546 29.0334 6.9117 29.0671 7.32373C29.0993 7.71734 29.0998 8.20298 29.0998 8.80035V8.80038L29.0997 32.2503C29.0997 32.467 28.9829 32.6669 28.794 32.7732C28.6051 32.8795 28.3736 32.8757 28.1884 32.7632L18.389 26.8136L17.9998 26.5773L17.6105 26.8136L7.8112 32.7632C7.62594 32.8757 7.39443 32.8795 7.20556 32.7732C7.01669 32.6669 6.89981 32.467 6.89981 32.2503L6.89981 8.80031V8.80028C6.89978 8.20288 6.9003 7.71736 6.93246 7.32373C6.96612 6.9117 7.03747 6.546 7.21044 6.20652C7.48368 5.67026 7.91968 5.23426 8.45594 4.96102C8.79542 4.78805 9.16112 4.7167 9.57315 4.68304C9.96678 4.65088 10.4524 4.65036 11.0498 4.65039Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmark-icon.d92dd3f8bf1b261ebe60d43e5d585cd2.svg";
export { ForwardRef as ReactComponent };